import React, {useLayoutEffect} from 'react';
import Header, {HeaderLeft, HeaderRight} from '../../../layout/Header/Header';
import useDeviceScreen from '../../../hooks/useDeviceScreen';
import useDarkMode from "../../../hooks/useDarkMode";
import ExchangeRate from "../../../components/dashboard/exchange-rate/ExchangeRate";
import Button, {IButtonProps} from "../../../components/bootstrap/Button";
import {useTranslation} from "react-i18next";
import LANG, {getLangWithKey, ILang} from "../../../lang";
import showNotification from "../../../components/extras/showNotification";
import Icon from "../../../components/icon/Icon";
import Dropdown, {DropdownItem, DropdownMenu, DropdownToggle} from "../../../components/bootstrap/Dropdown";
import Spinner from "../../../components/bootstrap/Spinner";

const DefaultHeader = () => {
    const {width} = useDeviceScreen();
    const {darkModeStatus} = useDarkMode();
    const user = JSON.parse(`${localStorage.getItem('user')}`);
    const styledBtn: IButtonProps = {
        color: 'dark',
        hoverShadow: 'default',
        isLight: !darkModeStatus,
        size: 'sm',
    };

    const {i18n} = useTranslation();
    const changeLanguage = (lng: ILang['key']['lng']) => {
        i18n.changeLanguage(lng);
        showNotification(
            <span className='d-flex align-items-center'>
				<Icon icon={getLangWithKey(lng)?.icon} size='lg' className='me-1'/>
				<span>{`Language changed to ${getLangWithKey(lng)?.text}`}</span>
			</span>,
            'You updated the language of the site.',
        );
    };

    /**
     * Language attribute
     */
    useLayoutEffect(() => {
        document.documentElement.setAttribute('lang', i18n.language);
    });
    return (
        <>
            {user?.token && (
                <Header>
                    <HeaderLeft>
                        <div style={{fontSize: '16px', fontWeight: 500}}
                             className={darkModeStatus ? 'text-light' : 'text-dark'}>
                            {`Hi, ${user?.lastName || ''}`}
                        </div>
                        <div className={`small ${darkModeStatus ? 'text-light' : 'text-muted'}`}>
                            {user?.email || ''}
                        </div>
                    </HeaderLeft>
                    <HeaderRight className={'d-flex align-items-center'}>
                        {/* Lang Selector */}
                        <div className='col-auto'>
                            <Dropdown>
                                <DropdownToggle hasIcon={false}>
                                    {typeof getLangWithKey(i18n.language as ILang['key']['lng'])?.icon ===
                                    'undefined' ? (
                                        <Button
                                            // eslint-disable-next-line react/jsx-props-no-spreading
                                            {...styledBtn}
                                            className='btn-only-icon'
                                            aria-label='Change language'
                                            data-tour='lang-selector'>
                                            <Spinner isSmall inButton='onlyIcon' isGrow />
                                        </Button>
                                    ) : (
                                        <Button
                                            // eslint-disable-next-line react/jsx-props-no-spreading
                                            {...styledBtn}
                                            icon={
                                                getLangWithKey(i18n.language as ILang['key']['lng'])?.icon
                                            }
                                            aria-label='Change language'
                                            data-tour='lang-selector'
                                        >
                                            {getLangWithKey(i18n.language as ILang['key']['lng'])?.text}
                                        </Button>
                                    )}
                                </DropdownToggle>
                                <DropdownMenu isAlignmentEnd data-tour='lang-selector-menu'>
                                    {Object.keys(LANG).map((i) => (
                                        <DropdownItem key={LANG[i].lng}>
                                            <Button
                                                icon={LANG[i].icon}
                                                onClick={() => changeLanguage(LANG[i].lng)}>
                                                {LANG[i].text}
                                            </Button>
                                        </DropdownItem>
                                    ))}
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                        <ExchangeRate/>
                    </HeaderRight>
                </Header>
            )}
        </>
    );
};

export default DefaultHeader;
